import { extendTheme } from "@chakra-ui/react";

const Theme = extendTheme({
    colors: {
        customGreen: {
            500: "#4A5A33", // Warna utama
            600: "#3E4A2B", // Warna lebih gelap untuk hover
        },
        customGold: {
            500: "#cbab70", // Warna utama
            600: "#C2BFA2", // Warna lebih gelap untuk hover
        }
    },
    components: {
        Button: {
            baseStyle: {
                fontWeight: "bold", // Semua tombol akan memiliki font tebal
                borderRadius: "lg", // Border radius default
            },
            sizes: {
                sm: {
                    fontSize: "12px",
                    px: 4, // Padding horizontal
                    py: 2, // Padding vertical
                },
                md: {
                    fontSize: "16px",
                    px: 6,
                    py: 3,
                },
            },
            variants: {
                solid: {
                    bg: "customGreen.500", // Gunakan warna kustom
                    color: "white",
                    _hover: {
                        bg: "customGreen.600", // Gunakan warna hover kustom
                    },
                },
                outline: {
                    border: "2px solid",
                    borderColor: "customGreen.500", // Gunakan warna kustom
                    color: "customGreen.500", // Gunakan warna kustom
                    _hover: {
                        bg: "customGreen.50", // Warna lebih terang untuk hover
                    },
                },
            },
            defaultProps: {
                size: "md", // Ukuran default
                variant: "solid", // Variasi default
            },
        },
    },
});

export default Theme;